<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar pl-0 pr-1">
            <v-layout row wrap>
              <v-flex xs12 md8 class="pl-1 pr-2">
                <v-card color="grey lighten-4" class="pa-2 mb-3 no__radius">
                  <v-card-title class="pa-1">
                    <v-layout row wrap align-center>
                      <v-flex :xs2="$vuetify.breakpoint.xs" shrink>
                        <v-icon class="mr-2" color="primary">people</v-icon>
                      </v-flex>
                      <v-flex :xs10="$vuetify.breakpoint.xs" grow>
                        <h2>Klienti a&nbsp;spolupracovníci</h2>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <hr class="mx-1 blue">
                  <v-card-text class="px-0 pb-1">
                    <v-layout row wrap class="mb-2">
                      <v-flex xs12 sm6 md3 lg3 xl2 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Noví klienti:</p>
                          <strong class="subtitle-1">
                            <router-link v-if="nastenka.novi_klienti > 0" :to="{ path: '/klienti' + '?n=1' }">{{nastenka.novi_klienti}}</router-link>
                            <span v-else>--</span>
                          </strong>
                        </v-card>
                      </v-flex>

                      <v-flex xs12 sm6 md3 lg3 xl2 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Noví spolupracovníci:</p>
                          <strong class="subtitle-1">
                            <router-link v-if="nastenka.novi_spolupracovnici > 0" :to="{ path: '/spolupracovnici' + '?n=1' }">{{nastenka.novi_spolupracovnici}}</router-link>
                            <span v-else>--</span>
                          </strong>
                        </v-card>
                      </v-flex>

                      <v-flex xs12 sm6 md3 lg3 xl2 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Aktuální počet klientů:</p> <strong class="subtitle-1">{{nastenka.pocet_klientu}}</strong>
                        </v-card>
                      </v-flex>

                      <v-flex xs12 sm6 md3 lg3 xl2 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Aktuální počet spolupracovníků:</p> <strong class="subtitle-1">{{nastenka.pocet_spolupracovniku}}</strong>
                        </v-card>
                      </v-flex>
                    </v-layout>

                    <v-flex xs12 class="px-1">
                      <h4 class="mb-2">Nové postupné nákupy:</h4>

                      <div class="table-border__radius table-dashboard elevation-1">
                        <v-data-table
                          :headers="headers"
                          :items="postupneNakupy"
                          :pagination.sync="paginationPostupneNakupy"
                          :total-items="paginationPostupneNakupy.totalItems"
                          :rows-per-page-items="[5, 10, 15, 20, 50]"
                          :loading="loadingPostupneNakupy"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.datum_sjednani | formatDate }}</td>
                            <td>
                              <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                                {{ props.item.osoba.nazev_osoby }}
                              </router-link>
                            </td>
                            <td>
                              <router-link :to="{ path: '/spolupracovnici/' + props.item.spolupracovnik.id }" target="_blank" v-if="props.item.spolupracovnik!=null">
                                {{ props.item.spolupracovnik.nazev_osoby }}
                              </router-link>
                            </td>
                            <td>
                              <router-link :to="{ path: '/sporici-produkty/' + props.item.sporici_produkt.id }" target="_blank" v-if="props.item.sporici_produkt!=null">
                                {{ props.item.sporici_produkt.sporici_program }}
                              </router-link>
                            </td>
                            <td>
                              <router-link :to="{ path: '/produkty/' + props.item.cilovy_produkt.id }" target="_blank" v-if="props.item.cilovy_produkt!=null">
                                {{ props.item.cilovy_produkt.nazev }}
                              </router-link>
                            </td>
                            <td class="text-xs-right">{{ props.item.cilova_castka | formatMoneyInt }} {{ props.item.mena.zkratka }}</td>
                            <td class="text-xs-right">{{ props.item.prvni_platba | formatMoneyInt }} {{ props.item.mena.zkratka }}</td>
                            <td class="text-xs-right">{{ props.item.mesicni_platba  | formatMoneyInt }} {{ props.item.mena.zkratka }}</td>
                            <td class="text-center">
                              <router-link :to="{ path: '/klienti/' + props.item.osoba.id + '/sporici-programy/' + props.item.id }" target="_blank">
                                <v-btn icon fab flat small color="primary" class="elevation-0 ma-0" @click="dialogDetail=true">
                                  <v-icon>remove_red_eye</v-icon>
                                </v-btn>
                              </router-link>
                            </td>
                          </template>
                        </v-data-table>
                      </div>
                    </v-flex>

                    <v-flex xs12 class="px-1 mt-3">
                      <h4 class="mb-2">Přehled jednorázových objednávek s přenesenou daňovou povinností:</h4>

                      <div class="table-border__radius table-dashboard elevation-1">
                        <v-data-table
                          :headers="headersJednorazoveObj"
                          :items="jednorazoveNakupy"
                          :pagination.sync="paginationJednorazoveNakupy"
                          :total-items="paginationJednorazoveNakupy.totalItems"
                          :rows-per-page-items="[5, 10, 15, 20, 50]"
                          :loading="loadingJednorazoveNakupy"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.datum | formatDate }} <div v-if="props.item.prenesena_dan" class="red--text">Přenesená daňová povinnost</div></td>
                            <td class="text-xs-right">{{ props.item.variabilni_symbol }}</td>
                            <td class="text-xs-right">{{ props.item.pocet_produktu }}</td>
                            <td class="text-xs-right">{{ props.item.castka_celkem | formatMoney }} {{props.item.mena.zkratka}}</td>
                            <td>
                              <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                                {{ props.item.osoba.nazev_osoby }}
                              </router-link>
                            </td>
                            <td>
                              {{ props.item.stav_objednavky.nazev }}
                            </td>
                            <td>
                              <router-link :to="{ path: '/spolupracovnici/' + props.item.poradce.id }" target="_blank" v-if="props.item.poradce != null">
                                {{ props.item.poradce.nazev_osoby }}
                              </router-link>
                            </td>
                            <td class="text-center">
                              <router-link :to="{ path: '/objednavky-jednorazove/' + props.item.id }">
                                <v-btn color="primary" class="elevation-0">
                                <v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                              </router-link>
                            </td>
                          </template>
                        </v-data-table>
                      </div>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 md4 class="pl-1 pr-2" :class="{ 'px-2' : $vuetify.breakpoint.smAndUp }">
                <v-card color="grey lighten-4" class="pt-2 px-2 pb-1 mb-3 no__radius" style="min-height:calc(100% - 16px)">
                  <v-card-title class="pa-1">
                    <v-layout row wrap align-center>
                      <v-flex :xs2="$vuetify.breakpoint.xs" shrink>
                        <v-icon class="mr-2" color="primary">build</v-icon>
                      </v-flex>
                      <v-flex :xs10="$vuetify.breakpoint.xs" grow>
                        <h2>Log systému</h2>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <hr class="mx-1 blue">
                  <v-card-text class="px-0 pb-2">
                    <v-layout row wrap>
                      <v-flex grow class="px-1">
                        <div class="table-border__radius elevation-1">
                          <v-data-table
                            :headers="headersLog"
                            :items="log"
                            :loading="loadingLog"
                            :pagination.sync="paginationLog"
                            :total-items="paginationLog.totalItems"
                            :rows-per-page-items="[5, 10, 15, 20, 50]"
                          >
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.id }}</td>
                              <td>{{ props.item.datum | formatDate }}</td>
                              <td>{{ props.item.identifikace }}</td>
                              <td><div v-html="th.makeText(props.item.predmet)"></div></td>
                            </template>
                          </v-data-table>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 md4 class="pl-1 pr-2" :class="{ 'px-2' : $vuetify.breakpoint.smAndUp }">
                <v-card color="grey lighten-4" class="pt-2 px-2 pb-1 mb-3 no__radius" style="min-height: calc(100% - 16px)">
                  <v-card-title class="pa-1">
                    <v-layout row wrap align-center>
                      <v-flex :xs2="$vuetify.breakpoint.xs" shrink>
                        <v-icon class="mr-2" color="primary">payment</v-icon>
                      </v-flex>
                      <v-flex :xs10="$vuetify.breakpoint.xs" grow>
                        <h2>Peněženka a&nbsp;pohledávky</h2>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <hr class="mx-1 blue">
                  <v-card-text class="px-0 pb-0">
                    <v-layout row wrap>
                      <v-flex grow class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Součet elektronických peněženek:</p> <strong class="subtitle-1">{{nastenka.suma_ep | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                      <v-flex grow class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Součet pohledávek:</p> <strong class="subtitle-1">{{nastenka.suma_poh | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 md4 class="pl-1 pr-2">
                <v-card color="grey lighten-4" class="pt-2 px-2 pb-1 mb-3 no__radius">
                  <v-card-title class="pa-1">
                    <v-layout row wrap align-center>
                      <v-flex shrink>
                        <v-icon class="mr-2" color="primary">gps_fixed</v-icon>
                      </v-flex>
                      <v-flex grow>
                        <h2>Fixace</h2>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <hr class="mx-1 blue">
                  <v-card-text class="px-0 pb-0">
                    <h4 class="mb-2 px-1">Fixované platby do postupných nákupů (splátky kovu):</h4>
                    <v-layout row wrap class="mb-2">
                      <v-flex xs12 sm6 md4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Za aktuální měsíc:</p> <strong class="subtitle-1">{{nastenka.fix_sporeni_tento_mesic | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 md4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Za předchozí měsíc:</p> <strong class="subtitle-1">{{nastenka.fix_sporeni_minuly_mesic | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 md4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Od 1.8.2019:</p> <strong class="subtitle-1">{{nastenka.fix_sporeni_vse | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                    </v-layout>

                    <h4 class="mb-2 px-1">Fixované platby do poplatku:</h4>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Za aktuální měsíc:</p> <strong class="subtitle-1">{{nastenka.fix_vstupni_poplatek_tento_mesic | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 md4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Za předchozí měsíc:</p> <strong class="subtitle-1">{{nastenka.fix_vstupni_poplatek_minuly_mesic | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 md4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Od 1.8.2019:</p> <strong class="subtitle-1">{{nastenka.fix_vstupni_poplatek_vse | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 md4 class="pl-1 pr-2" :class="{ 'px-2' : $vuetify.breakpoint.smAndUp }">
                <v-card color="grey lighten-4" class="pt-2 px-2 pb-1 mb-3 no__radius">
                  <v-card-title class="pa-1">
                    <v-layout row wrap align-center>
                      <v-flex shrink>
                        <v-icon class="mr-1" color="primary">attach_money</v-icon>
                      </v-flex>
                      <v-flex grow>
                        <h2>Provize a&nbsp;kredity</h2>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <hr class="mx-1 blue">
                  <v-card-text class="px-0 pb-0">
                    <h4 class="mb-2 px-1">Provize:</h4>
                    <v-layout row wrap class="mb-2">
                      <v-flex xs12 sm4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Celkem od začátku měsíce:</p> <strong class="subtitle-1">{{nastenka.provize_tento_mesic | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Celkem za předchozí měsíc:</p> <strong class="subtitle-1">{{nastenka.provize_predchozi_mesic | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <!-- TODO Provize za všechna období -->
                          <p class="caption font-weight-medium mb-0">Celkem za všechna období:</p> <strong class="subtitle-1">{{nastenka.provize_vse | formatMoney}} Kč</strong>
                        </v-card>
                      </v-flex>
                    </v-layout>

                    <h4 class="mb-2 px-1">Kredity:</h4>
                    <v-layout row wrap>
                      <v-flex xs12 sm4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Celkem od začátku měsíce:</p> <strong class="subtitle-1">{{nastenka.kredity_tento_mesic | formatMoney}} kr.</strong>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <p class="caption font-weight-medium mb-0">Celkem za předchozí měsíc:</p> <strong class="subtitle-1">{{nastenka.kredity_predchozi_mesic | formatMoney}} kr.</strong>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm4 class="px-1">
                        <v-card class="no__radius pa-2 mb-2">
                          <!-- TODO Kredity za všechna období -->
                          <p class="caption font-weight-medium mb-0">Celkem za všechna období:</p> <strong class="subtitle-1">{{nastenka.kredity_vse | formatMoney}} kr.</strong>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      loadingPostupneNakupy: false,
      loadingJednorazoveNakupy: false,
      loadingLog: false,
      headers: [
        { text: 'Datum sjednání', value: 'datum_sjednani', width: '300px' },
        { text: 'Klient', value: 'osoba' },
        { text: 'Spolupracovník', value: 'spolupracovnik' },
        { text: 'Spořící program', value: 'sporici_produkt' },
        { text: 'Cílový produkt', value: 'cilovy_produkt' },
        { text: 'Cílová částka', value: 'cilova_castka', align: 'right' },
        { text: '1. platba', value: 'prvni_platba', align: 'right' },
        { text: 'Měs. splátka', value: 'mesicni_platba', align: 'right' },
        { text: 'Detail', value: null, sortable: false, align: 'center' }
      ],
      headersJednorazoveObj: [
        { text: 'Datum', value: 'datum' },
        { text: 'Číslo objednávky (VS)', value: 'variabilni_symbol', align: "right" },
        { text: 'Počet produktů', value: 'pocet_produktu', align: "right" },
        { text: 'Celková cena', value: 'castka_celkem', align: "right" },
        { text: 'Klient', value: 'osoba' },
        { text: 'Stav', value: 'stav_objednavky', sortable: false },
        { text: 'Poradce', value: 'poradce', sortable: false },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      headersLog: [
        { text: 'ID', value: 'id', width: '30px' },
        { text: 'Datum', value: 'datum' },
        { text: 'Identifikace', value: 'identifikace', sortable: false},
        { text: 'Předmět', value: 'predmet', sortable: false},
        // { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      headersNewClient: [
        { text: 'Jméno a příjmení', value: 'jmeno' },
        { text: 'Detail', value: null, sortable: false },
      ],
      itemsNewClient: [

      ],
      postupneNakupy: [],
      jednorazoveNakupy: [],
      log: [],
      itemsLog: [],
      item: {},
      counterPostupneNakupy: 0,
      counterJednorazoveNakupy: 0,
      counterLog: 0,
      paginationPostupneNakupy: {
        descending: true,
        page: 1,
        rowsPerPage: 5,
        sortBy: "datum_sjednani",
        totalItems: 0
      },
      paginationJednorazoveNakupy: {
        descending: true,
        page: 1,
        rowsPerPage: 5,
        sortBy: "datum",
        totalItems: 0
      },
      paginationLog: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: "id",
        totalItems: 0
      },
      nastenka: null
    }
  },
  props: {
    id: String
  },
  computed: {
    api_url_admin () {
      return window.api.$api_url;
    },
    th () {
      return window.th;
    }
  },
  watch: {
    paginationPostupneNakupy: {
      handler () {
        this.loadSjednanaSporeni();
      },
      deep: true
    },
    paginationJednorazoveNakupy: {
      handler () {
        this.loadJednorazoveNakupy();
      },
      deep: true
    },
    paginationLog: {
      handler () {
        this.loadLog();
      },
      deep: true
    },
  },
  mounted: function() {
    this.load();
    this.loadSjednanaSporeni();
    this.loadLog();
  },
  methods: {
    load: function() {
      window.API.get("nastenka").then(function(body) {
        this.nastenka = body;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    loadSjednanaSporeni () {
      this.counterPostupneNakupy++;
      this.loadingPostupneNakupy = true;
      window.API.post("prehledy/sjednana-sporeni/search", {
        pagination: this.paginationPostupneNakupy,
        s: this.search,
        echo: this.counterPostupneNakupy,
      }).then(function(body) {
        if (this.counterPostupneNakupy != body.echo)
          return;
        this.postupneNakupy.replace(body.data);
        this.paginationPostupneNakupy.sortBy = body.sort.sortBy;
        this.paginationPostupneNakupy.descending = body.sort.descending;
        this.paginationPostupneNakupy.page = body.sort.page;
        this.paginationPostupneNakupy.rowsPerPage = body.sort.rowsPerPage;
        this.paginationPostupneNakupy.totalItems = body.sort.totalItems;
        this.loadingPostupneNakupy = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    loadJednorazoveNakupy () {
      this.counterJednorazoveNakupy++;
      this.loadingJednorazoveNakupy = true;
      window.API.post("prehledy/jednorazove-nakupy/search", {
        pagination: this.paginationJednorazoveNakupy,
        s: this.search,
        echo: this.counterJednorazoveNakupy,
        preneseni_dan_povinnosti: true
      }).then(function(body) {
        if (this.counterJednorazoveNakupy != body.echo)
          return;
        this.jednorazoveNakupy.replace(body.data);
        this.paginationJednorazoveNakupy.sortBy = body.sort.sortBy;
        this.paginationJednorazoveNakupy.descending = body.sort.descending;
        this.paginationJednorazoveNakupy.page = body.sort.page;
        this.paginationJednorazoveNakupy.rowsPerPage = body.sort.rowsPerPage;
        this.paginationJednorazoveNakupy.totalItems = body.sort.totalItems;
        this.loadingJednorazoveNakupy = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    loadLog () {
      this.counterLog++;
      this.loadingLog = true;
      window.API.post("log/search", {
        pagination: this.paginationLog,
        s: this.search,
        echo: this.counterLog,
      }).then(function(body) {
        if (this.counterLog != body.echo)
          return;
        this.log.replace(body.data);
        this.paginationLog.sortBy = body.sort.sortBy;
        this.paginationLog.descending = body.sort.descending;
        this.paginationLog.page = body.sort.page;
        this.paginationLog.rowsPerPage = body.sort.rowsPerPage;
        this.paginationLog.totalItems = body.sort.totalItems;
        this.loadingLog = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Domu.vue